export enum DocumentType {
  INVOICE = 'invoice',
  QUOTE = 'estimate',
  HISTORY = 'history',
}
